import { getAdminPath } from "../util/router";

export function createNotification(jsonString) {
   if (!("Notification" in window)) {
      //Questo browser non supporta le notifiche
      return;
   }

   if (Notification.permission !== "granted") {
      return;
   }

   const { userId, message } = jsonString;

   try {
      const json = JSON.parse(message);
      const { title, body, section, id } = json;

      const notification = new Notification(title, {
         body,
         icon: `${process.env.REACT_APP_BASE_URL}/favicon.png`,
         tag: `${userId}-${section}-${id}`,
         requireInteraction: true,
      });

      const link = generateSectionUrl(section, id);

      if (link) {
         notification.onclick = (e) => {
            e.preventDefault();
            window.open(link, "_self");
         };
      }
   } catch (error) {
      console.error("Error creating notification:", error);
      return;
   }
}

function generateSectionUrl(section, id = null) {
   if (!section) return null;

   switch (section) {
      case "task-manager":
         return getAdminPath(id ? `task-manager/?t=${id}` : "task-manager");
      default:
         return null;
   }
}
